import React, { useLayoutEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { PPPresetSelector } from "../../components/pricetable/PPPresetSelector"
import PPCategorieFilter from "../../components/pricetable/PPCategorieFilter"
import PPShopFilter from "../../components/pricetable/PPShopFilter"
import PPPriceFilter from "../../components/pricetable/PPPriceFilter"

function filterButtonClass(open) {
    return `btn mx-1 ${open ? "btn-primary" : "btn-outline-primary"}`
}

function PPPriceTableHeader(props) {
    const [t] = useTranslation()
    const [catOpen, setCatOpen] = useState(false)
    const [shopOpen, setShopOpen] = useState(false)
    const [priceOpen, setPriceOpen] = useState(false)

    return (
        <div className="container-fluid mb-2">
            <div className="row d-flex align-items-center">
                <div className="col-8 d-flex justify-content-start align-items-center flex-wrap gap-1">
                    <button
                        id="buttonPricetableFilterCollapseCatfilter"
                        className={filterButtonClass(catOpen)}
                        type="button"
                        onClick={() => {
                            setCatOpen((open) => !open)
                            document.body.classList.toggle("filtercat_open")
                        }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseCatfilter"
                        aria-expanded={catOpen}
                        aria-controls="collapseCatfilter"
                    >
                        <i className="fas fa-filter" /> {t("single.category_filter")}
                    </button>
                    <button
                        id="buttonPricetableFilterCollapseShopfilter"
                        className={filterButtonClass(shopOpen)}
                        type="button"
                        onClick={() => {
                            setShopOpen((open) => !open)
                            document.body.classList.toggle("filtershop_open")
                        }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseShopFilter"
                        aria-expanded={shopOpen}
                        aria-controls="collapseShopFilter"
                    >
                        <i className="fas fa-filter" /> {t("shop_filter.title")}
                    </button>
                    <button
                        id="buttonPricetableFilterCollapsePricefilter"
                        className={filterButtonClass(priceOpen)}
                        type="button"
                        onClick={() => {
                            setPriceOpen((open) => !open)
                            document.body.classList.toggle("filterprice_open")
                        }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsePriceFilter"
                        aria-expanded={priceOpen}
                        aria-controls="collapsePriceFilter"
                    >
                        <i className="fas fa-filter" /> {t("price_filter.title")}
                    </button>
                    <button
                        id="buttonPricetableExort"
                        className="btn btn-outline-primary mx-1"
                        type="button"
                        aria-expanded="false"
                        aria-controls="exportPricetable"
                        data-bs-toggle="modal"
                        data-bs-target="#createPricetableExportDialog"
                        disabled={props.countProducts == 0}
                    >
                        <i className="fas fa-file-excel" /> {t("single.export")}
                    </button>
                </div>

                <div className="col-3 d-flex justify-content-end align-items-center">
                    {localStorage.getItem("switchCurrency") === "true" && (
                        <div
                            className="badge badge-warning me-2"
                            style={{ whiteSpace: "normal", maxWidth: "80px", lineHeight: "1.3" }}
                        >
                            {t("settings.pricetable.switchCurrency.badge")}
                        </div>
                    )}
                    <div className="pricetable-filter-row-font me-2">Preset</div>
                    <PPPresetSelector
                        presetId={props.preset?.id}
                        id="selectPricetablePresetSelector"
                        changePresetId={props.changePresetId}
                        presets={props.presets}
                    />
                </div>
                <div className="col-1 d-flex justify-content-start align-items-center">
                    <PPCellStyleSlider />
                </div>
            </div>
            <div className="flex-grow-1 collapse m-1 mt-2" id="collapseCatfilter">
                <div>
                    <h5>{t("single.category_filter")}</h5>
                    <PPCategorieFilter
                        onChangeCatFilter={props.onChangeCatFilter}
                        presetId={props.preset?.id}
                        filters={props.filters}
                    />
                </div>
            </div>
            <div className="flex-grow-1 collapse m-1 mt-2" id="collapseShopFilter">
                <div>
                    <h5>{t("shop_filter.title")}</h5>
                    <PPShopFilter preset={props.preset} handleSort={props.handleSort} />
                </div>
            </div>
            <div className="flex-grow-1 collapse m-1 mt-2" id="collapsePriceFilter">
                <div>
                    <h5>{t("price_filter.title")}</h5>
                    <PPPriceFilter preset={props.preset} handleSort={props.handleSort} />
                </div>
            </div>
            <div
                className="modal fade"
                id="createPricetableExportDialog"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="createPricetableExportDialogLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="createPricetableExportDialogLabel">
                                Export
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            {t("pricetable.export_dialog.question", { countProducts: props.countProducts })}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                {t("pricetable.export_dialog.cancel")}
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    props.triggerPricetableExport()
                                }}
                            >
                                {t("pricetable.export_dialog.create")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function PPCellStyleSlider() {
    function configureCell(value) {
        const hide = value < 70
        document.querySelectorAll(".stockbox, .pricecell-subsubline").forEach((el) => {
            el.style.display = hide ? "none" : ""
        })
        document.querySelectorAll(".pricetext").forEach((el) => {
            el.style.marginBottom = hide ? "0" : "0.45rem"
        })
        document.querySelectorAll(".subline").forEach((el) => {
            el.style.display = value < 80 ? "none" : ""
        })
    }

    function getPriceCellHeight() {
        if (localStorage.getItem("pricebox-height") > 0) {
            setPriceboxHeight(localStorage.getItem("pricebox-height"))
        }
        return parseInt(getComputedStyle(document.body).getPropertyValue("--pricebox-height"))
    }

    useLayoutEffect(() => {
        configureCell(getPriceCellHeight())
    })

    function setPriceboxHeight(value) {
        document.documentElement.style.setProperty("--pricebox-height", parseInt(value) + "px")
        configureCell(value)
    }

    return (
        <input
            type="range"
            className="form-range"
            list="tickmarks"
            defaultValue={getPriceCellHeight()}
            min={50}
            max={100}
            id="customRange1"
            onChange={(event) => {
                let value = event.target.value
                localStorage.setItem("pricebox-height", value)
                setPriceboxHeight(value)
            }}
        />
    )
}

export { PPPriceTableHeader, PPCellStyleSlider }
